(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["recommendations"] && !Shopify.designMode) return;
  try {
    
const productRecommendationsSection = document.querySelector('.product-recommendations');
const productRecommendationsSectionWrapper = document.querySelector('.product-recommendations-wrapper');
const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(productRecommendationsSection);
    const url = productRecommendationsSection.dataset.url;
    fetch(url)
      .then(response => response.text())
      .then(text => {

        const html = document.createElement('div');
        html.innerHTML = text;

        const recommendations = html.querySelector('.product-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
            // Show the title
            const titleElement = document.querySelector('[product-recommendations-title]');
            if (titleElement) {
                titleElement.classList.remove('hidden');
            }
            // Replace the content with fetched recommendations
            productRecommendationsSection.innerHTML = recommendations.innerHTML;
            // Show the wrapper
            productRecommendationsSectionWrapper.classList.remove('hidden');

            // Initialize swiper if there's a swiper element
            const swiperElement = productRecommendationsSection.querySelector('.swiper');
            if (swiperElement && typeof window.reinitSwiper === 'function') {
                window.reinitSwiper(swiperElement);
            }
        } else {
            // Hide the wrapper if no recommendations
            productRecommendationsSectionWrapper.classList.add('hidden');
        }
    })
    .catch(e => {
        console.error('Error fetching recommendations:', e);
    });
};

const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
